"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createRef() {
    var refObject = (function (element) {
        refObject.value = element;
    });
    refObject.value = null;
    return refObject;
}
exports.createRef = createRef;
//# sourceMappingURL=createRef.js.map